<template>
  <no-ssr>
  <section class="container-full">
      <header-inner/>
      <wrapper :lineBorders="false" :lineCenter="true" class="page--top">
        <!--<p>Возможно она появится здесь позже, или когда-то была здесь раньше. Попробуйте поискать что-то ещё.</p>-->
        <div class="content">
          <div class="title"><h1>Данной страницы<br> не существует</h1></div>
        </div>
      </wrapper>

  </section>
  </no-ssr>
</template>


<script>

  import PageFooter from "../components/footer/PageFooter";
  import HeaderInner from "../components/header/HeaderInner";

  export default {
    components: {
      HeaderInner,
      PageFooter
    }
  }
</script>
<style lang="scss" scoped>
   .content {
      position: relative;
      background: url("/images/404/404.png") no-repeat;
      background-position: center top;
      background-size: 100%;
      width: 100%;
      padding-bottom: 100%;
      .title {
         color: $color-white;
         @include position-full();
         left: 40%;
         bottom: 18%;
         display: flex;
         align-items: center;
         justify-content: center;
         h1 {
           width: 100%;
          // $media_lg
           @media (max-width: $media_lg) {
              font-size: 3.5vw;
           }
           @media (max-width: $media_sm) {
             font-size:4vw;
           }
         }
      }
   }
</style>



// WEBPACK FOOTER //
// layouts/error.vue